import React from 'react'
import { Avatar, Status, Icon, HorizontalStack, ShowIf, TooltipPopOver } from '@ztechapps/webui.util'
import { PhoneNumberDisplay } from '../PhoneNumber/PhoneNumberDisplay'

type UserWidgetProps = {
  profile: { name: string; picture: string; email: string }
  status: string
  phone?: string
}
/**
 * This is  the default display for user,
 * @constructor
 */
export const UserWidget = ({ profile, status, phone }: UserWidgetProps) => {
  const { name, picture, email } = profile ?? {}

  return (
    <HorizontalStack className="justify-content-start align-items-center">
      <div className="me-1">
        <Avatar name={name} src={picture} />
      </div>
      <div style={{ minWidth: 0 }}>
        <HorizontalStack className="align-items-center">
          <span className="flex-shrink-0">
            <Status value={status} />
          </span>{' '}
          <TooltipPopOver tooltipBody={profile?.name}>
            <span className="fw-bold text-truncate">{name}</span>
          </TooltipPopOver>
        </HorizontalStack>
        <TooltipPopOver tooltipBody={profile?.email}>
          <div className="small text-truncate">
            <Icon name="envelope" /> {email}
          </div>
        </TooltipPopOver>
        <ShowIf condition={!!phone}>
          <div className="small">
            <Icon name="phone" /> <PhoneNumberDisplay value={phone} />
          </div>
        </ShowIf>
      </div>
    </HorizontalStack>
  )
}
